import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupLandingPageRoutingModule } from './group-landing.page.routing.module';
import { GroupLandingPageComponent } from './group-landing-page.component';


@NgModule({
  declarations: [
    GroupLandingPageComponent
  ],
  imports: [
    CommonModule,
    GroupLandingPageRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GroupLandingPageModule { }
